import { DependenciesInjection } from "app/di/DependencyInjection";
import { IPackageLookupRepository } from "../domain/repositories/IPackageLookupRepository";
import { PackageLookupUseCase } from "../domain/useCases/PackageLookupUseCase";
import { PackageLookupToken } from "./PackageLookupToken";
import { PackageLookupImpl } from "../data/PackageLookupImpl";
import { PackageLookupViewModel } from "../presentation/viewModel/PackageLookupViewModel";

export class PackageLookupInjection {
  static initInjections() {
    DependenciesInjection.register<IPackageLookupRepository>(
      PackageLookupToken.IPackageLookupRepository,
      PackageLookupImpl,
      "otherRepo",
    );
    DependenciesInjection.register<PackageLookupUseCase>(
      PackageLookupToken.PackageLookupUseCase,
      PackageLookupUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<PackageLookupViewModel>(
      PackageLookupToken.PackageLookupViewModel,
      PackageLookupViewModel,
      "viewModel",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<IPackageLookupRepository>(
      PackageLookupToken.IPackageLookupRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<PackageLookupUseCase>(
      PackageLookupToken.PackageLookupUseCase,
    );
  }

  static getViewModel() {
    return DependenciesInjection.getRepo<PackageLookupViewModel>(
      PackageLookupToken.PackageLookupViewModel,
    );
  }
}
